import { useAnalytics } from '@townsquare/analytics';
import { getModifiedShortcut, useKeyboardShortcut } from '@townsquare/keyboard-shortcuts';
import { GO_FOR_YOU_SHORTCUT, GO_PROJECTS_PAGE_SHORTCUT } from '@townsquare/keyboard-shortcuts/constants';
import { useKeyboardShortcutStore } from '@townsquare/keyboard-shortcuts/store';
import { useRouterActions } from '@townsquare/router/primitives/actions';
import { projectDirectoryRoute } from '@townsquare/routes/project-directory-view';

export const useKeyboardShortcuts = (): void => {
	const analytics = useAnalytics();
	const { pushTo } = useRouterActions();
	const [{ type }] = useKeyboardShortcutStore();

	const handleGoToKeypress = (_e: KeyboardEvent, keypress: string | undefined) => {
		switch (keypress) {
			case getModifiedShortcut(type, GO_FOR_YOU_SHORTCUT):
				void analytics.ui('keyboardShortcut', 'pressed', { shortcutType: type }, 'goHomePageShortcut');
				void pushTo(projectDirectoryRoute);
				break;
			case getModifiedShortcut(type, GO_PROJECTS_PAGE_SHORTCUT):
				void analytics.ui('keyboardShortcut', 'pressed', { shortcutType: type }, 'goProjectsPageShortcut');
				void pushTo(projectDirectoryRoute);
				break;
		}
	};

	// eslint-disable-next-line react-hooks/rules-of-hooks
	useKeyboardShortcut(GO_FOR_YOU_SHORTCUT, handleGoToKeypress);
	// eslint-disable-next-line react-hooks/rules-of-hooks
	useKeyboardShortcut(GO_PROJECTS_PAGE_SHORTCUT, handleGoToKeypress);
};
